module.exports = __webpack_public_path__ + "img/group-7@3x.8407ec44.png";